import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/entities/user';
import { useCurrentWorkspaceId } from '@/entities';
import { templatesQueryOptions, type TemplatesScope } from './templates.api';

export function useTemplatesScope(): TemplatesScope {
  const organizationId = useAuth((s) => s.signedInUser.value?.organization.id ?? '');
  const workspaceId = useCurrentWorkspaceId();
  return { organizationId, workspaceId: workspaceId ?? null };
}

/**
 * Read-only templates list. Deliberately carries no mutation state so callers that only need a
 * count (the Knowledge Hub card) don't mount the write path.
 */
export function useEmailTemplates() {
  const scope = useTemplatesScope();
  const query = useQuery(templatesQueryOptions(scope));

  return {
    templates: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
